import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  IExtendableDto,
  NO_GROUPING_QS_VALUE,
  ridesJourneyAF,
  shouldDebugReactTable,
  useRydeTable,
} from "@ryde/shared";

import { useTableDefsRidesNestedGrid } from "./use-table-defs-rides-nested-grid";

export const useTableNestedGrid = () => {
  const { id: journeyIdFromForm } = useCrudEditContext();
  const ridesJourney = useRecoilValue(ridesJourneyAF(journeyIdFromForm || 0));
  const { RidesNestedGridTableDefs } = useTableDefsRidesNestedGrid();

  const getRowIdCB = useCallback((row: IExtendableDto) => {
    return String(row?.id);
  }, []);

  const table = useRydeTable({
    data: ridesJourney ?? [],
    meta: { groupingField: undefined, groupingValue: NO_GROUPING_QS_VALUE },
    columns: RidesNestedGridTableDefs,
    manualPagination: false,
    getRowCanExpand: () => true,
    debugTable: shouldDebugReactTable(),
    autoResetPageIndex: false,
    autoResetExpanded: false,
    getRowId: getRowIdCB,
  });

  return {
    table,
  };
};
